import { PERM } from '@/shared/auth/types'
import type { NavSection } from '@/app/nav'

/**
 * The Billing module's sidebar menu.
 *
 * Deliberately a static array in the client, not rows in a database table.
 * The monitoring application drives its sidebar from MS_MENU, and adding rows
 * there would make its live sidebar render our routes through its own AJAX
 * shell -- so that table stays untouched. What the server does own is the
 * answer to "may this user see it", which arrives at login as the permission
 * map; every item below is filtered through it.
 *
 * Beranda is not in this list. It lives in the top bar (logo and module
 * switcher), because the sidebar answers "which page of Billing", not "which
 * application" -- see docs/konvensi-ui.md.
 */
export const BILLING_NAV: NavSection[] = [
  {
    items: [{ label: 'Ringkasan', to: '/billing', icon: 'grid', end: true }],
  },
  {
    title: 'Billing',
    items: [
      { label: 'Proforma', to: '/billing/proforma', icon: 'document', permCode: PERM.BILLING_PROFORMA },
      { label: 'Persetujuan', to: '/billing/approvals', icon: 'check', permCode: PERM.BILLING_APPROVAL },
      { label: 'Invoice', to: '/billing/invoices', icon: 'receipt', permCode: PERM.BILLING_INVOICE },
      { label: 'Rekonsiliasi', to: '/billing/reconciliation', icon: 'scale', permCode: PERM.BILLING_RECON },
    ],
  },
  {
    title: 'Data Master',
    items: [
      { label: 'Pelanggan', to: '/billing/customers', icon: 'building', permCode: PERM.BILLING_CUSTOMER },
    ],
  },
  {
    title: 'Pengaturan',
    items: [
      {
        label: 'Matriks Persetujuan',
        to: '/billing/settings/approval-matrix',
        icon: 'sliders',
        permCode: PERM.BILLING_MATRIX,
        action: 'edit',
      },
      {
        label: 'Rekening Penerimaan',
        to: '/billing/settings/receiving-accounts',
        icon: 'bank',
        permCode: PERM.BILLING_BANK_ACCOUNT,
      },
      {
        label: 'Hak Akses',
        to: '/billing/settings/permissions',
        icon: 'users',
        permCode: PERM.BILLING_ADMIN,
        action: 'edit',
      },
      {
        label: 'Log Aktivitas',
        to: '/billing/settings/audit',
        icon: 'clipboard',
        permCode: PERM.BILLING_ADMIN,
      },
    ],
  },
  {
    title: 'Akun',
    items: [
      // No permCode: everyone who can reach the shell has an account, and
      // gating your own profile behind a grant is how people end up unable to
      // change their own password.
      { label: 'Notifikasi', to: '/billing/notifications', icon: 'bell' },
      { label: 'Profil & Preferensi', to: '/billing/account', icon: 'user', end: true },
    ],
  },
]
